




























































































import {Component} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import {ScrollButton} from "wings-ui-components";
import SystemSettingsFilter from "@/components/Settings/SystemSettings/SystemSettingsFilter.vue";
import { SystemSettingItem } from '@/store/settings/system_settings/types';
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import { notifyError, notifySuccess } from '@/utils/notify-helper';
import axios from 'axios';
import {ActionLog} from "@/store/auth/types";

@Component({components: {SystemSettingsFilter, ScrollButton}})
export default class SystemSettings extends BaseItemsPage<SystemSettingItem> {
  @Getter("systemSettings") systemSettingsResponse: any;
  @Action("syncCaches") actionSyncCaches: any;
  @Action("syncTemplates") actionSyncTemplates: any;
  @Action("actionLog") actionLog: any;

  is_show_filter = false;
  currentSort= "name";
  currentSortOrder= "desc";
  tableFields = ['name', 'value', 'description'];
  private logObject: ActionLog = {};

  getData(): any {
    return this.systemSettingsResponse;
  }

  async syncCaches() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Synchronization",
        action_status: "success",
        object_type: "Cache",
      }
      let resp = await this.actionSyncCaches();
      await this.actionLog(this.logObject);
      if (resp.status === 200) {
        notifySuccess();
      } else {
        let msg = 'Status: ' + resp.data.status + '. Expected: "Success".';
        notifyError(msg);
      }
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    }
  }

    async syncTemplates() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Synchronization",
        action_status: "success",
        object_type: "Template",
      }
      let resp = await this.actionSyncTemplates();
      await this.actionLog(this.logObject);
      if (resp.status === 200) {
        notifySuccess();
      } else {
        let msg = 'Status: ' + resp.data.status + '. Expected: "Success".';
        notifyError(msg);
      }
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    }
  }
}
